module.exports = "/pages/business/foodslabo/thanks_bg.png";